import { NgModule } from '@angular/core';
import { UiModule } from './ui/ui.module';
import { ComponentsModule } from './components/components.module';

@NgModule({
    imports: [UiModule, ComponentsModule],
    exports: [UiModule, ComponentsModule],
})
export class SharedModule {}
